import {
  RESET_ORDER_EDITION,
  INITIALIZE_ORDER_EDITION,
  SET_ORDER_EDITION_INFO,
  SET_DELIVERY_INFO,
  SET_BILLING_INFO,
  SET_CUSTOMER,
  SET_COMPANY,
  SET_TENDER,
  SET_CONFIRM_TENDER,
  SET_FORMAT,
  UPDATE_ORDER_ITEMS,
  ADD_ORDER_ITEM,
  REMOVE_ORDER_ITEM,
  UPDATE_ORDER_ITEM,
  MOVE_ORDER_ITEM,
  UPDATE_REDUCTION,
  UPDATE_REDUCTIONS,
  UPDATE_ORDER_DELIVERY_COST,
  ADD_ORDER,
  SET_CURRENT_ORDER_INDEX,
  REMOVE_ORDER,
  MOVE_ORDER,
  SET_ORDER_STATUS,
  SET_GROUPED_ORDER_STATUS,
  SET_ORDER_DELIVERY_INFO,
  SET_ORDER_SERVICE_INFO,
  FETCH_BREAKFAST_ORDER,
  FETCH_BREAKFAST_ORDER_COMPLETED,
  FETCH_BREAKFAST_ORDER_FAILED,
  FETCH_GROUPED_ORDER,
  FETCH_GROUPED_ORDER_COMPLETED,
  FETCH_GROUPED_ORDER_FAILED,
  SAVE_ORDER,
  SAVE_ORDER_COMPLETED,
  SAVE_ORDER_FAILED,
  SAVE_BREAKFAST_ORDER,
  SAVE_BREAKFAST_ORDER_COMPLETED,
  SAVE_BREAKFAST_ORDER_FAILED,
  SET_ORDER_INFO,
  UPDATE_ORDER_PRICE_INFO,
  GET_CLONE_GROUPED_ORDER,
  GET_CLONE_GROUPED_ORDER_COMPLETED,
  GET_CLONE_GROUPED_ORDER_FAILED,
  DUPLICATE_ORDER,
  SET_ORDER_BRIQUE_DEVIS,
  SET_ORDER_BRIQUE_MODE,
} from "./actions";
import { breakfastOrderApiToStore, orderStateToTotal, groupedOrderApiToStore } from "helper/transformDataHelper";
import { indexAfterRemoval } from "helper/prestationIndex";

const initialState = {
  deliveryInfo: {
    firstname: "",
    lastname: "",
    streetNumber: "",
    street: "",
    postalCode: "",
    city: "",
    phone: "",
    phoneSecondary: "",
    startAt: "",
    endAt: "",
    arrivedAtStart: "",
    arrivedAtEnd: "",
    person: 0,
    addressComplement: "",
  },
  billingInfo: {
    firstname: "",
    lastname: "",
    phone: "",
    addressComplement: "",
    fullAddress: "",
    service: "",
  },
  customer: {},
  company: {},
  tender: {},
  confirmTender: false,
  status: null,
  currentOrder: {},
  currentOrderIndex: null,
  customerSpecialCommentary: null, // Commentaire du client
  customerSpecialReference: null, // Référence client
  customerQuotationCommentary: null, // Commentaire visible devis factures
  codeServiceChorus: null, // Code Chorus
  orderFormDate: null, // Date de réception du bon de commande
  disableApproachingMail: false, // Relance en approche
  groupedOrderId: null,
  groupedOrderUpdatedAt: null,
  groupedOrderTotalHT: null, // HT de la commande groupée (API, dernière sauvegarde)
  groupedOrderTotalTTC: null, // TTC de la commande groupée (API, TVA par taux)
  groupedOrderStatus: null,
  accountManager: null,
  savInProgress: false,
  orders: [
    // {
    //   id: null,
    //   prestationType: null,
    //   format: null,
    //   blanket: false,
    //   packagingType: null,
    //   service: false,
    //   commentaryForProd: "",
    //   status: "101",
    //   deliveryInfo: {
    //     startAt: "",
    //     endAt: "",
    //     deliveryDate: "",
    //     person: "",
    //     arrivedAtStart: "",
    //     arrivedAtEnd: "",
    //     specific: false,
    //   },
    //   reduction: {
    //     label: null,
    //     direct: null,
    //     proportional: null,
    //   },
    //   priceInfo : {
    //     total_ht: null,
    //     pricingTable: {},
    //   },
    //   deliveryCost: 0,
    //   items: [],
    //   priceInfo: {
    //      totalHT: 0
    //      totalHTWithoutReduction: 0,
    //      catererPackagePiecesPriceHtPerParticipant: null,
    //      catererPackageSoftsPriceHtPerParticipant: null,
    //      catererPackageAlcoholsPriceHtPerParticipant: null,
    //   },
    //   info: {},
    //   version: 'v2',
    // articles: [
    //   {
    //     quantity: 1,
    //     price: 0,
    //     group: "",
    //     product: "",
    //     article_id: null,
    //   },
    //   {
    //     quantity: 1,
    //     price: 0,
    //     group: "",
    //     article_id: null;
    //     child: [
    //       {
    //         quantity: 1,
    //         price: 0,
    //         group: "",
    //         product: "",
    //         id: null,
    //       },
    //     ],
    //   }
    // ],
    // },
  ],
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ORDER_EDITION:
      return initialState;
    case INITIALIZE_ORDER_EDITION:
      return {
        ...state,
        ...initialState,
      };
    case SET_ORDER_EDITION_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case SET_DELIVERY_INFO:
      return {
        ...state,
        deliveryInfo: {
          ...action.payload,
          deliveryAddressBook: action.payload.deliveryAddressBook || state.deliveryInfo.deliveryAddressBook,
        },
      };
    case SET_BILLING_INFO:
      return {
        ...state,
        billingInfo: action.payload,
      };
    case SET_CUSTOMER:
      return {
        ...state,
        customer: action.payload,
      };
    case SET_COMPANY:
      return {
        ...state,
        company: action.payload,
      };
    case SET_TENDER:
      return {
        ...state,
        tender: action.payload,
      };
    case SET_CONFIRM_TENDER:
      return {
        ...state,
        confirmTender: action.payload,
      };
    case SET_FORMAT:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            // Auto-déduit le `prestationType` à partir du `prestation_type` porté
            // par le tag format (cf. seed §1.5 du runbook backend). L'utilisateur
            // n'a plus à choisir le type séparément — le format dicte le type.
            // Fallback : si le tag n'a pas de `prestation_type` (cas legacy d'un
            // format string sans tag, ou tag créé avant la migration), on garde
            // l'ancien `prestationType` plutôt que de l'écraser à null.
            const deducedType = action.payload.formatTag?.prestation_type
              ?? order.prestationType
              ?? null;
            return {
              ...order,
              format: action.payload.formatTxt,
              formatTagId: action.payload.formatTag?.id || null,
              prestationType: deducedType,
            };
          }
          return order;
        }),
      };
    case SAVE_ORDER:
      return {
        ...state,
        isLoading: true,
      };
    case SAVE_ORDER_COMPLETED: {
      const prevOrders = state.orders;
      const hasOrders = action?.payload?.result?.groupedOrder?.orders.length > 0;
      const base = hasOrders ? groupedOrderApiToStore(action.payload.result.groupedOrder) : initialState;
      const mergedOrders =
        hasOrders && base.orders
          ? base.orders.map((o, idx) => {
              // Retrouve la prestation du state courant par id (fiable même si l'ordre
              // de la réponse diffère) ; fallback par index pour les prestations tout
              // juste créées (duplication : pas encore d'id dans prevOrders).
              const prev =
                (o.id && prevOrders.find((p) => p.id === o.id)) || prevOrders[idx];
              return {
                ...o,
                // Briques non persistées côté API → on conserve le state React courant
                briqueDevis: prev?.briqueDevis ?? o.briqueDevis ?? [],
                // briqMode vient de l'API (is_brique_mode), fallback sur le state courant
                briqMode: o.briqMode ?? prev?.briqMode ?? false,
              };
            })
          : base.orders;
      return {
        ...state,
        isLoading: false,
        ...base,
        ...(mergedOrders ? { orders: mergedOrders } : {}),
        groupedOrderId: action.payload?.result?.groupedOrder?.id || null,
        groupedOrderStatus: action.payload?.result?.groupedOrder?.status || null,
        groupedOrderUpdatedAt: action.payload?.result?.groupedOrder?.last_save_from_api || null,
        groupedOrderTotalHT: action.payload?.result?.groupedOrder?.total_price_ht ?? null,
        groupedOrderTotalTTC: action.payload?.result?.groupedOrder?.total_price_ttc ?? null,
      };
    }
    case SAVE_ORDER_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case SAVE_BREAKFAST_ORDER:
      return {
        ...state,
        isLoading: true,
      };
    case SAVE_BREAKFAST_ORDER_COMPLETED:
      return {
        ...state,
        isLoading: false
      };
    case SAVE_BREAKFAST_ORDER_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case UPDATE_ORDER_ITEMS:
      return {
        ...state,
        orders: state.orders.map((order, index) => {

          // Ajoute items si non défini
          if (order.items === undefined) {
            order.items = [];
          }

          if (index === action.payload.orderIndex) {
            const newItems = action.payload.items;
            const itemType = action.payload.itemType;
    
            let updatedItems;
            if (itemType === 'formula') {
              // Filtrer les éléments existants pour exclure les formules
              updatedItems = order.items.filter(item => item.type !== 'formula');
              // Ajouter les nouvelles formules
              updatedItems = [...updatedItems, ...newItems.map(item => ({...item, type: itemType}))];
            } else if (itemType === 'product') {
              // Filtrer les éléments existants pour exclure les produits simples
              updatedItems = order.items.filter(item => item.type !== 'product');
              // Ajouter les nouveaux produits simples
              updatedItems = [...updatedItems, ...newItems.map(item => ({...item, type: itemType}))];
            } else if (itemType === 'productGroup') {
              // Filtrer les éléments existants pour exclure les groupes
              updatedItems = order.items.filter(item => item.type !== 'productGroup');
              // Ajouter les nouveaux groupes
              updatedItems = [...updatedItems, ...newItems.map(item => ({...item, type: itemType}))];
            } else if (itemType === 'productPackage') {
              // Filtrer les éléments existants pour exclure les groupes
              updatedItems = order.items.filter(item => item.type !== 'productPackage');
              // Ajouter les nouveaux groupes
              updatedItems = [...updatedItems, ...newItems.map(item => ({...item, type: itemType}))];
            }
            else if (!itemType) {
              updatedItems = newItems;
            }

            const {
              totalHT,
              totalHTWithoutReduction
            } = orderStateToTotal({ ...order, items: updatedItems });
    
            return {
              ...order,
              items: updatedItems,
              priceInfo: {
                ...order.priceInfo,
                totalHT: totalHT,
                totalHTWithoutReduction: totalHTWithoutReduction
              }
            };
          }
          return order;
        }),
    };
    case ADD_ORDER_ITEM: {
      const { orderIndex, item } = action.payload;
      const updatedOrders = [...state.orders];
      const updatedOrder = {
        ...updatedOrders[orderIndex],
        items: [...updatedOrders[orderIndex].items, item],
      };

      const {
        totalHT,
        totalHTWithoutReduction: totalHTWithoutReduction
      } = orderStateToTotal({ ...updatedOrder, items: updatedOrder.items });

      updatedOrders[orderIndex] = {
        ...updatedOrder,
        priceInfo: {
          ...updatedOrder.priceInfo,
          totalHT: totalHT,
          totalHTWithoutReduction: totalHTWithoutReduction
        }
      };

      return {
        ...state,
        orders: updatedOrders,
      };
    }
    case REMOVE_ORDER_ITEM: {
      const { orderIndex, itemIndex } = action.payload;
      const updatedOrders = [...state.orders];
      const updatedOrder = {
        ...updatedOrders[orderIndex],
        items: updatedOrders[orderIndex].items.filter((_, i) => i !== itemIndex),
      };

      const {
        totalHT,
        totalHTWithoutReduction
      } = orderStateToTotal({ ...updatedOrder, items: updatedOrder.items });

      updatedOrders[orderIndex] = {
        ...updatedOrder,
        priceInfo: {
          ...updatedOrder.priceInfo,
          totalHT: totalHT,
          totalHTWithoutReduction: totalHTWithoutReduction
        }
      };
      return {
        ...state,
        orders: updatedOrders,
      };
    }
    case UPDATE_ORDER_ITEM: {
      const { orderIndex, itemIndex, item } = action.payload;
      const updatedOrders = [...state.orders];
      const updatedOrder = {
        ...updatedOrders[orderIndex],
        items: updatedOrders[orderIndex].items.map((el, i) => (i === itemIndex ? item : el)),
      };

      const {
        totalHT,
        totalHTWithoutReduction
      } = orderStateToTotal({ ...updatedOrder, items: updatedOrder.items });

      updatedOrders[orderIndex] = {
        ...updatedOrder,
        priceInfo: {
          ...updatedOrder.priceInfo,
          totalHT: totalHT,
          totalHTWithoutReduction: totalHTWithoutReduction
        }
      };

      return {
        ...state,
        orders: updatedOrders,
      };
    }
    case MOVE_ORDER_ITEM: {
      const { orderIndex, itemIndex, direction, itemType } = action.payload;
      const updatedOrders = [...state.orders];
      const order = updatedOrders[orderIndex];
      
      // Filtrer les items du même type pour obtenir leur index relatif
      const itemsOfType = order.items
        .map((item, index) => ({ item, originalIndex: index }))
        .filter(({ item }) => item.type === itemType);
      
      // Trouver l'index dans la liste filtrée
      const relativeIndex = itemsOfType.findIndex(({ originalIndex }) => originalIndex === itemIndex);
      
      if (relativeIndex === -1) {
        return state;
      }
      
      // Calculer le nouvel index
      const newRelativeIndex = direction === 'up' ? relativeIndex - 1 : relativeIndex + 1;
      
      if (newRelativeIndex < 0 || newRelativeIndex >= itemsOfType.length) {
        return state;
      }
      
      // Obtenir les index originaux
      const currentOriginalIndex = itemsOfType[relativeIndex].originalIndex;
      const targetOriginalIndex = itemsOfType[newRelativeIndex].originalIndex;
      
      // Créer un nouveau tableau d'items avec les éléments échangés
      const newItems = [...order.items];
      [newItems[currentOriginalIndex], newItems[targetOriginalIndex]] = 
        [newItems[targetOriginalIndex], newItems[currentOriginalIndex]];
      
      const updatedOrder = {
        ...order,
        items: newItems,
      };

      const {
        totalHT,
        totalHTWithoutReduction
      } = orderStateToTotal({ ...updatedOrder, items: updatedOrder.items });

      updatedOrders[orderIndex] = {
        ...updatedOrder,
        priceInfo: {
          ...updatedOrder.priceInfo,
          totalHT: totalHT,
          totalHTWithoutReduction: totalHTWithoutReduction
        }
      };

      return {
        ...state,
        orders: updatedOrders,
      };
    }
    case UPDATE_REDUCTION:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            const newReduction = action.payload.reduction;
            const {
              totalHT,
              totalHTWithoutReduction
            } = orderStateToTotal({ ...order, reduction: newReduction });
            return {
              ...order,
              reduction: newReduction,
              priceInfo: {
                ...order.priceInfo,
                totalHT: totalHT,
                totalHTWithoutReduction: totalHTWithoutReduction
              }
            };
          }
          return order;
        }),
      };
    case UPDATE_REDUCTIONS:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            const newReductions = Array.isArray(action.payload.reductions) ? action.payload.reductions : [];
            const {
              totalHT,
              totalHTWithoutReduction
            } = orderStateToTotal({ ...order, reductions: newReductions });
            return {
              ...order,
              reductions: newReductions,
              // On garde l'ancien champ unique cohérent (1re réduction) pour
              // tout consommateur legacy.
              reduction: newReductions[0] || { label: null, direct: null, proportional: null },
              priceInfo: {
                ...order.priceInfo,
                totalHT: totalHT,
                totalHTWithoutReduction: totalHTWithoutReduction
              }
            };
          }
          return order;
        }),
      };
    case UPDATE_ORDER_DELIVERY_COST:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            const newCost = action.payload.cost;
            const {
              totalHT,
              totalHTWithoutReduction
            } = orderStateToTotal({ ...order, deliveryCost: newCost });
            return {
              ...order,
              deliveryCost: newCost,
              priceInfo: {
                ...order.priceInfo,
                totalHT: totalHT,
                totalHTWithoutReduction: totalHTWithoutReduction
              }
            };
          }
          return order;
        }),
      };
    case ADD_ORDER:
      const formatTag = action.payload.formatTag;
      return {
        ...state,
        currentOrderIndex: state.orders.length - 1 < 0 ? 0 : state.orders.length,
        orders: [
          ...state.orders,
          {
            prestationType: action.payload.prestationType,
            format: formatTag?.name || null,
            formatTagId: formatTag?.id || null,
            version: 'v2',
            reductions: [],
            reduction: {
              label: null,
              direct: null,
              proportional: null,
            },
            deliveryCost: 0,
            items: [],
            priceInfo: {
              totalHT: 0,
              totalHTWithoutReduction: 0,
              catererPackagePiecesPriceHtPerParticipant: null,
              catererPackageSoftsPriceHtPerParticipant: null,
              catererPackageAlcoholsPriceHtPerParticipant: null,
              useClassicPricing: action.payload.prestationType === 'caterer' ? true : null,
            },
            deliveryInfo: {
              startAt: "",
              endAt: "",
              deliveryDate: "",
              person: "",
              arrivedAtStart: "",
              arrivedAtEnd: "",
              specific: false,
              deliveryInformation: state?.deliveryInfo?.deliveryAddressBook?.delivery_information || "",
              recoverInformation: state?.deliveryInfo?.deliveryAddressBook?.recover_information || "",
            },
            serviceInfo: {
              masterCount: 1,
              waiterCount: 0
            },
            googleCalendarEventId: null,
            briqueDevis: [],
            briqMode: true,
          },
        ],
      };
    case SET_ORDER_BRIQUE_DEVIS:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            return {
              ...order,
              briqueDevis: action.payload.briques,
            };
          }
          return order;
        }),
      };
    case SET_ORDER_BRIQUE_MODE:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            return {
              ...order,
              briqMode: action.payload.briqMode,
            };
          }
          return order;
        }),
      };
    case SET_CURRENT_ORDER_INDEX:
      return {
        ...state,
        currentOrderIndex: action.payload,
      };
    case MOVE_ORDER: {
      const { fromIndex, toIndex } = action.payload;
      if (
        fromIndex === toIndex ||
        fromIndex < 0 || fromIndex >= state.orders.length ||
        toIndex < 0 || toIndex >= state.orders.length
      ) {
        return state;
      }
      const movedOrders = [...state.orders];
      const [movedOrder] = movedOrders.splice(fromIndex, 1);
      movedOrders.splice(toIndex, 0, movedOrder);

      // La prestation ouverte (currentOrderIndex) suit son nouvel index
      let currentOrderIndex = state.currentOrderIndex;
      if (currentOrderIndex === fromIndex) {
        currentOrderIndex = toIndex;
      } else if (currentOrderIndex !== null && currentOrderIndex !== undefined) {
        if (fromIndex < currentOrderIndex && toIndex >= currentOrderIndex) {
          currentOrderIndex = currentOrderIndex - 1;
        } else if (fromIndex > currentOrderIndex && toIndex <= currentOrderIndex) {
          currentOrderIndex = currentOrderIndex + 1;
        }
      }

      return {
        ...state,
        orders: movedOrders,
        currentOrderIndex: currentOrderIndex,
      };
    }
    case REMOVE_ORDER:
      const orders = state.orders.filter((order, index) => index !== action.payload);
      // Reste sur la prestation ouverte (même calcul que l'URL, cf. handleRemoveOrder)
      const newCurrentOrderIndex = indexAfterRemoval(state.currentOrderIndex, action.payload, orders.length);

      return {
        ...state,
        currentOrderIndex: newCurrentOrderIndex,
        orders: orders,
      };
    case SET_ORDER_STATUS:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            return {
              ...order,
              status: action.payload.status,
            };
          }
          return order;
        }),
      };
    case SET_GROUPED_ORDER_STATUS:
      return {
        ...state,
        status: action.payload.status,
      };
    case SET_ORDER_DELIVERY_INFO:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            return {
              ...order,
              deliveryInfo: {
                ...action.payload.deliveryInfo
              },
            };
          }
          return order;
        }),
      };
    case SET_ORDER_SERVICE_INFO:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            return {
              ...order,
              serviceInfo: {
                ...(order.serviceInfo || {}),
                ...action.payload.serviceInfo
              },
            };
          }
          return order;
        }),
      };
    case FETCH_BREAKFAST_ORDER:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_BREAKFAST_ORDER_COMPLETED:
      return {
        ...state,
        isLoading: false,
        ...breakfastOrderApiToStore(action.payload.result),
        currentOrderIndex: 0,
      };
    case FETCH_BREAKFAST_ORDER_FAILED:
      return {
        ...state,
        isLoading: false,
      };
      case FETCH_GROUPED_ORDER:
        return {
          ...state,
          isLoading: true,
        };
      case FETCH_GROUPED_ORDER_COMPLETED:
        let status = '101';
        if (action.payload?.result?.status) {
          status = action.payload?.result?.status;
        }
        if (status >= 400) {
          status = '401';
        }
        return {
          ...state,
          isLoading: false,
          ...action?.payload?.result?.orders.length > 0 ? groupedOrderApiToStore(action.payload.result) : initialState,
          groupedOrderId: action.payload?.result?.id || null,
          groupedOrderStatus: status,
          groupedOrderUpdatedAt: action.payload?.result?.last_save_from_api || null,
          groupedOrderTotalHT: action.payload?.result?.total_price_ht ?? null,
          groupedOrderTotalTTC: action.payload?.result?.total_price_ttc ?? null,
          status: status,
        };
      case FETCH_GROUPED_ORDER_FAILED:
        return {
          ...state,
          isLoading: false,
        };
    case SET_ORDER_INFO:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            return {
              ...order,
              ...action.payload.order,
            };
          }
          return order;
        }),
      };
    case UPDATE_ORDER_PRICE_INFO:
      return {
        ...state,
        orders: state.orders.map((order, index) => {
          if (index === action.payload.orderIndex) {
            const newPriceInfo = action.payload.priceInfo;
            const {
              totalHT,
              totalHTWithoutReduction
            } = orderStateToTotal({
              ...order,
              priceInfo: newPriceInfo,
            });
            return {
              ...order,
              priceInfo: {
                ...newPriceInfo,
                totalHT: totalHT,
                totalHTWithoutReduction: totalHTWithoutReduction
              },
            };
          }
          return order;
        }),
      };
    case GET_CLONE_GROUPED_ORDER:
      return {
        ...state,
        isLoading: true,
      };
    case GET_CLONE_GROUPED_ORDER_COMPLETED:
      return {
        ...state,
        isLoading: false,
        ...groupedOrderApiToStore(action.payload.result.groupedOrder),
        groupedOrderId: action.payload?.result?.groupedOrder?.id || null,
        groupedOrderStatus: action.payload?.result?.groupedOrder?.status || null,
        groupedOrderUpdatedAt: action.payload?.result?.groupedOrder?.last_save_from_api || null,
        groupedOrderTotalHT: action.payload?.result?.groupedOrder?.total_price_ht ?? null,
        groupedOrderTotalTTC: action.payload?.result?.groupedOrder?.total_price_ttc ?? null,
      };
    case GET_CLONE_GROUPED_ORDER_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case DUPLICATE_ORDER: {
      const { orderIndex } = action.payload;
      const order = state.orders[orderIndex];
      if (!order) {
        return state;
      }

      let newOrder = {
        ...order,
        id: null,
        status: "101",
        // Copies indépendantes : le spread superficiel partagerait ces objets entre
        // l'original et la copie (une mutation toucherait les deux prestations).
        deliveryInfo: { ...(order.deliveryInfo || {}) },
        serviceInfo: { ...(order.serviceInfo || {}) },
        priceInfo: { ...(order.priceInfo || {}) },
        reduction: { ...(order.reduction || {}) },
        // La copie n'est pas encore sauvegardée : pas de numéro de prestation ni de
        // documents — ceux de l'original ne doivent pas s'afficher sur la copie.
        info: {},
      };
      if (Array.isArray(newOrder.briqueDevis)) {
        newOrder.briqueDevis = newOrder.briqueDevis.map((b) => ({
          ...b,
          _devisId: `devis_brique_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
        }));
      }
      // Supprime les références aux ids des articles
      newOrder.items = newOrder.items.map(item => {
        return {
          ...item,
          article_id: null,
          products: item?.products && item.products.map(product => {
            return {
              ...product,
              id: null,
              // article_id est l'id de l'article enfant de l'ORIGINAL : envoyé tel quel
              // au save de la copie sinon (ignoré par le backend, mais payload trompeur).
              article_id: null,
            };
          }),
          product_parts: item?.product_parts && item.product_parts.map(productPart => {
            return {
              ...productPart,
              id: null,
              article_id: null,
            };
          })
        };
      });
      const orders = [...state.orders];
      orders.splice(orderIndex + 1, 0, newOrder);

      return {
        ...state,
        orders,
        currentOrderIndex: orderIndex + 1,
      };
    }
    default:
      return state;
  }
};

export default reducers;
